import React, { Component } from 'react'
import PropTypes from 'prop-types'
import * as R from 'ramda'
import { compose } from 'recompose'
import Dialog from 'react-toolbox/lib/dialog'
import T from 'i18n-react'
import CSSModules from 'helpers/CSSModulesUtil'

import Input from './Input'

import styles from './styles.scss'

import {
  MODULE_NAME,
} from './constants'

class RejectDialog extends Component {
  onCancel = () => this.props.disableDialog()
  onSubmit = () => this.props.onSubmit()

  actions = [
    { label: 'Cancel', onClick: this.onCancel },
    { label: 'Submit', onClick: this.onSubmit },
  ]

  render() {
    const {
      active,
      comment,
      onUpdateComment,
      disableDialog
    } = this.props

    return (
      <Dialog
        actions={this.actions}
        active={active}
        title={T.translate('containers.approval.approvalDialog.rejectDialog.title')}
        onOverlayClick={disableDialog}
        onEscKeyDown={disableDialog}
        type='small'
      >
        <Input
          value={comment}
          onChange={onUpdateComment}
        />
      </Dialog>
    )
  }
}

const withStyle = CSSModules(styles)
export default compose(
  withStyle
)(RejectDialog)
